import React from "react";

const defaultProps = {
  height: "85.7mm",
  width: "54.22mm",

  hasBack: false,
  resident: {
    first_name: "Strike",
    middle_name: "B.",
    last_name: "Revilla",
    picture: "/mayor-strike.png",
    signature: "/placeholder-signature.png",
    address: "Molino 3 Bacoor City Cavite",
    birthdate: "03/02/1970",
    civil_status: "Married",
    precinct_number: "197-D",
    mobile: "09869867858",
    id_number: "09869867858",
  },
  incase_emergency: {
    first_name: "Strike",
    middle_name: "B.",
    last_name: "Revilla",
    mobile: "09869867858",
    address: "Molino 3 Bacoor City Cavite",
  },
  city: {
    name: "BACOOR",
    logo: "/bacoor-logo.png",
    mayorLogo: "/strike.png",
  },
  barangay: {
    name: "QUEENS ROW CENTRAL",
    logo: "/barangay.png",
    captain_signature: "/placeholder-signature.png",
    officials: [
      {
        name: "Strike Revilla",
        position: "PUNONG BARANGAY",
      },
    ],
  },
  valid: "12/31/23",
};

function EmployeeId({
  barangay,
  resident,
  incase_emergency,
  city,
  valid,
  width,
  height,
  hasBack,
  employees,
  o,
}) {
  const captain =
    (barangay.officials &&
      barangay.officials.find(
        (official) => official.position === "PUNONG BARANGAY"
      )) ||
    {};
  const employee = employees;

  const renderFront = () => {
    const style = {
      width: "54.22mm",
      height: "85.85mm",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundImage: `url("/3.png")`,
    };
    return (
      <div>
        <div className="text-dark" style={{ ...style }}>
          <div>
            <div className="text-center"></div>
            <div className="text-center">
              <img
                className="p-0 rounded"
                // src={employee?.employeeImage || "/h.png"}
                src={"/h.png"}
                height="130"
                style={{
                  margin: "85px 0px 0px -70px",
                }}
              />
            </div>
            {/* <div className="text-center mt-2">
              <p
                className="fw-bold"
                style={{ margin: "25px 0 0 110px", fontSize: "11px" }}
              >
                {employee?.employeeId}
              </p>
            </div> */}
            <div className="text-center" style={{ margin: "30px 0 0 -80px" }}>
              <p
                className="fw-bold"
                style={{
                  fontSize: "10px",
                  marginBottom: "1px",
                  color: "green",
                }}
              >
                {employee?.firstName} {employee?.middleName}{" "}
                {employee?.lastName}
              </p>
              <p className="text-dark fw-bold" style={{ fontSize: "10px" }}></p>
              <p
                className=""
                style={{ fontSize: "10px", marginTop: "-20px", color: "green" }}
              >
                {employee?.position}
              </p>
              {/* <p  
                className="text-dark fw-bold "
                style={{ fontSize: "10px", marginTop: "5px" }}
              >
                SY 2025-2026
              </p> */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderBack = () => {
    const style = {
      width: "54.22mm",
      height: "85.85mm",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundImage: `url("/4.png")`,
    };
    return (
      <div>
        <div className=" text-dark mt-2" style={{ ...style }}>
          <div className="text-center" style={{ paddingTop: "90px" }}>
            <h5
              className="fw-bold"
              style={{
                fontSize: "10px",
                marginBottom: "1px",
                color: "green",
              }}
            >
              Nelson Santos
            </h5>
            <p
              style={{
                fontSize: "8px",
                marginBottom: "1px",
                color: "green",
              }}
            >
              Partner
            </p>
            <p
              style={{
                fontSize: "8px",
                marginBottom: "1px",
                color: "green",
              }}
            >
              10 Gil Pascual Street Hulong Duhat
            </p>
            <p
              style={{
                fontSize: "8px",
                marginBottom: "1px",
                color: "green",
              }}
            >
              Malabon City
            </p>
            <p
              style={{
                fontSize: "8px",
                marginBottom: "1px",
                color: "green",
              }}
            >
              0945-397-0271
            </p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      {renderFront()}
      {renderBack()}
    </div>
  );
}

EmployeeId.defaultProps = defaultProps;
export default EmployeeId;
